import { render, staticRenderFns } from "./DeleteConfirmationDialog.vue?vue&type=template&id=4175555b&"
import script from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeleteConfirmationDialog.vue"
export default component.exports